import axios from 'axios';

class FacebookAPI {
  fbWhatsAppAuth(phone_number_id, code) {
    return axios.post('/api/v1/facebook/whatsapp_auth', { phone_number_id, code });
  }

  fbWhatsAppRegister(phone_number_id, waba_id, webhook_url, verify_token, access_token) {
    return axios.post('/api/v1/facebook/whatsapp_register',
      {
        phone_number_id,
        waba_id,
        webhook_url,
        verify_token
      },
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
  }
}

export default new FacebookAPI();
